import { handleSnackbarOpen } from "@/services/slices/main-slice";
import { fetchBaseQuery, retry } from "@reduxjs/toolkit/query/react";

/**
 * Custom base query with error handling.
 */
const baseQueryWithErrorHandling = async (
	args: any,
	api: any,
	extraOptions: any
) => {
	const isFormData = args?.formData === true;

	const headers: any = {};

	if (!isFormData) {
		headers["Content-Type"] = "application/json";
	}
	
	if (typeof window !== "undefined" && localStorage.getItem('token')) {
		headers["Authorization"] = 'Bearer ' + localStorage.getItem('token');
	}

	const result = await fetchBaseQuery({
		baseUrl: process.env.API_URL,
		redirect: "follow",
		headers: headers,
	})(args, api, extraOptions);
	if (result.error) {
		let { status } = result.error;
		if (status === 422) {
			const errorData: any = result.error.data;
			let message: any;
			if (errorData.data.hasOwnProperty("message")) {
				message = errorData.data.message;
				api.dispatch(
					handleSnackbarOpen({
						severity: "error",
						message: message,
					})
				);
			}
			if (errorData.data.hasOwnProperty("errors")) {
				Object.entries(errorData.data.errors).map(([, value]) => {
					const messages: any = value;
					api.dispatch(
						handleSnackbarOpen({
							severity: "error",
							message: messages[0],
						})
					);
				});
			}
			return {
				error: {
					status,
					data:
						errorData?.data ?? "Something went wrong. Please try again later.",
				},
			};
		} else if (status === 403) {
			console.error("Error detected:", result.error);
			// Log or send the error to the backend

			api.dispatch(
				handleSnackbarOpen({
					severity: "error",
					message: "دسترسی ندارید",
				})
			);

			// Modify the error message to return custom error data for the UI
			return {
				error: {
					status,
					data: "Something went wrong. Please try again later.",
				},
			};
		} else if (status === 401) {
			console.error("Error detected:", result.error);

			// Redirect to the login page or another appropriate route
			// if (typeof window !== "undefined" && localStorage.getItem('token')) {
			// 	localStorage.removeItem('token');
			// }

			// window.location.href =
			// 	"/login?redirect_url=" + btoa(window.location.href);

			// Modify the error message to return custom error data for the UI
			return {
				error: {
					status,
					data: "Something went wrong. Please try again later.",
				},
			};
		} else if (status === 500) {
			api.dispatch(
				handleSnackbarOpen({
					severity: "error",
					message: "Something went wrong. Please try again later.",
				})
			);

			// Modify the error message to return custom error data for the UI
			return {
				error: {
					status,
					data: "Something went wrong. Please try again later.",
				},
			};
		}
	}

	return result;
};

// Retry mechanism with the enhanced baseQuery
export const baseQueryWithRetry = retry(baseQueryWithErrorHandling, {
	maxRetries: 0,
});
